import styled from '@emotion/styled'
import React from 'react'

import { CTAButtonWithWT } from '@f-fertighaus/applications/Next/components/common/CTAButton'
import { DesktopOnly } from '@f-fertighaus/applications/Next/components/common/MediaQuery'
import { t } from '@f-fertighaus/applications/Next/public/locales/de'
import { useHouseDetail } from '@f-fertighaus/applications/Next/utils/context/HouseDetail'

const VendorLogoBackground = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 90px;
  height: 90px;
  background-color: ${({ theme }) => theme.palette.background.paper};
  box-shadow: 2px 2px 5px 0 rgb(0 0 0 / 10%);
  left: 0;
  bottom: 16px;
  padding: 4px;
  border-radius: var(--border-radius-card-large);

  img {
    object-fit: contain;
    object-position: center;
    max-height: 100%;
  }

  ${({ theme }) => theme.breakpoints.up('md')} {
    width: 150px;
    height: 150px;
    left: 16px;
    bottom: 0;
    padding: 10px;
  }
`
const ContentWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  position: relative;
`

export const VendorLogoCtaSection = () => {
  const { state, vendor } = useHouseDetail()

  return (
    <ContentWrapper>
      <VendorLogoBackground>
        <img src={vendor.logo['max-320x240.noauto']} alt='vendor-logo' />
      </VendorLogoBackground>
      <DesktopOnly>
        <CTAButtonWithWT
          disabled={!state.active}
          className='js-request-button'
          data-request-type='house-detail-form'
          data-funnel-variant='house-wizard-item-catalog'
          variant='outlined'
          color='primary'
          wtPayload={{
            category: 'CTA-button',
            action: 'click',
            label: 'catalog-request',
            indicates: ['funnel-entry'],
            location: 'vendor-section',
            values: [
              {
                type: 'text',
                value: t('houseDetailPage.vendor.request-catalog')
              }
            ]
          }}
          {...(state.vendor_nid && { 'data-vendor-nid': state.vendor_nid })}>
          {t('houseDetailPage.vendor.request-catalog')}
        </CTAButtonWithWT>
      </DesktopOnly>
    </ContentWrapper>
  )
}
